import { render } from "./L_LeftPart.vue?vue&type=template&id=62b745c6"
import script from "./L_LeftPart.vue?vue&type=script&lang=js"
export * from "./L_LeftPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__